<template>
  <div id="contents" class="service-intro">
    <div class="inner">
      <h3 class="main-title">서비스소개</h3>
      <ul class="tab-wrap">
        <li><a href="/service/hometown" class="tab-btn">SKB 우리동네광고</a></li>
        <li><a href="/service/skylife" class="tab-btn">KT스카이라이프 IPTV광고</a></li>
        <li><a href="/service/experience" class="tab-btn">체험단 마케팅</a></li>
        <li><a href="/service/reporter" class="tab-btn">기자단 마케팅</a></li>
        <li><a href="/service/insta" class="tab-btn">인스타 마케팅</a></li>
        <li><a href="/service/viral" class="tab-btn active">바이럴 마케팅</a></li>
      </ul>
    </div>
    <div class="service-intro-wrap intro06">
      <section class="sec01">
        <div class="inner flexbox center">
          <div class="title-wrap">
            <h4 class="section-title">효율적이고 정확한 타겟을 공략</h4>
            <p class="section-desc">다양한 콘텐츠 보유는 기본, 직접 지역카페 콘텐츠 및 댓글 작성을 통한 우리매장의 광고를 전략적으로 진행합니다.<br>  또한, 필요시 온라인 언론보도 서비스와의 연계를 통해 신뢰도 상승을 추구 합니다.</p>
          </div>
        </div>
      </section>
      <section class="sec02">
        <div class="inner">
          <ul class="list type-btn">
            <li>
                <span class="round-box">
                  <img src="../resource/images/ico_service_intro17.png" alt=""/>
                  <span class="tx-blue">맞춤 댓글 관리</span>
                </span>
            </li>
            <li>
                <span class="round-box">
                  <img src="../resource/images/ico_service_intro07.png" alt=""/>
                  특정지역, 특정사람에 대한&nbsp;<span class="tx-blue">타겟 마케팅</span>
                </span>
            </li>
            <li>
                <span class="round-box">
                  <img src="../resource/images/ico_service_intro18.png" alt=""/>
                  <span class="tx-blue">회원 신뢰도 보장</span>
                </span>
            </li>
            <li>
                <span class="round-box">
                  <img src="../resource/images/ico_service_intro19.png" alt=""/>
                  홍보공간이 아닌 100%&nbsp;<span class="tx-blue">정보공유 공간</span>
                </span>
            </li>
            <li>
                <span class="round-box">
                  <img src="../resource/images/ico_service_intro20.png" alt=""/>
                  <span class="tx-blue">2/3차 광고 효과</span>
                </span>
            </li>
            <li>
                <span class="round-box">
                  <img src="../resource/images/ico_service_intro21.png" alt=""/>
                  <span class="tx-blue">정확한 쪽지 관리</span>
                </span>
            </li>
          </ul>
        </div>
      </section>
      <section class="sec04">
        <div class="inner small">
          <h4 class="section-sub-title">타겟 예시</h4>
          <div class="flexbox start">
            <img src="../resource/images/img_portfolio06.png" alt=""/>
            <img src="../resource/images/img_portfolio06.png" alt=""/>
            <div class="balloon">지역별 / 특징별 커뮤니티 활용 가능</div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>
<script>

export default {
  name: 'page-notice',
  components: {

  },
  data () {
    return {
      curWidth: 2.5
    }
  },
  mounted() {
    if (document.body.clientWidth < 800) {
      this.curWidth = 1
    }
    document.body.classList.add('sub');
    this.scroll();
  },
  methods: {
    scroll() {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || window.screenY;
      document.querySelectorAll("section").forEach(item => {
        if(scrollTop > item.offsetTop - window.innerHeight / this.curWidth){
          item.classList.add("on");
        }
      });
      window.requestAnimationFrame(this.scroll);
    }
  }
}

</script>